import React from "react";
import { PrivacyPolicyPopup } from "./PrivacyPolicyPopup";
import { IntroNotificationPopup } from "./IntroNotificationPopup";
import { TwoFactorVerificationSetupPopup } from "./TwoFactorVerificationSetupPopup";

export function GlobalPopups() {
  return (
    <>
      <PrivacyPolicyPopup />
      <IntroNotificationPopup />
      <TwoFactorVerificationSetupPopup />
    </>
  );
}
